import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { CHAT_TYPE } from "sr/i18n/messages/setting";
import { getMessage } from "sr/utils/api/cleaner/getMessage";

export const fetchCleanerNotification = createAsyncThunk(
  "cleanerNotification",
  async (params: any) => {
    const queryParams = new URLSearchParams();
    queryParams?.append("recipient_id", params?.cleanerId);
    const query = {
      $or: [
        { sender_id_type: "individual" },
        { sender_id_type: "system" },
        { sender_id_type: "company" },
      ],
    };
    queryParams.append("filter", JSON.stringify(query));
    queryParams.append("limit", "1000");
    // queryParams.append('readed', 'false')
    try {
      const res = await getMessage(queryParams);
      if (res?.success === true) {
      const messages = [];
      for (let i = 0; i < res?.data?.length; i++) {
        if (
          Object.values(CHAT_TYPE)?.includes(res?.data[i]?.type) ||
          res?.data[i]?.sender_id_type === "system" ||
          res?.data[i]?.sender_id_type === "company"
        ) {
          messages.push(res?.data[i]);
        }
      }
        return messages;
      } else {
      }
    } catch (e) {}
  }
);

interface initialState {
  data: any;
  isLoading: Boolean;
  isError: Boolean;
}

const initialState: initialState = {
  data: null,
  isLoading: false,
  isError: false,
};
const cleanerNotificationSlice = createSlice({
  name: "fetchCleanerNotification",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchCleanerNotification.pending, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(fetchCleanerNotification.fulfilled, (state, action) => {
      state.data = action.payload;
    });
    builder.addCase(fetchCleanerNotification.rejected, (state, action) => {
      state.isError = true;
    });
  },
  reducers: {
    updateNotificationMessage: (state, action) => {
      state.data = action.payload;
    },
    removeNotificationMessage: (state, action) => {
      if (action?.payload?.id) {
        state.data = state?.data?.filter(
          (item) => item?._id !== action?.payload?.id
        );
      } else {
        state.data = [];
      }
    },
    markCleanerNotificationAsRead: (state, action) => {
        const { id, jobId, senderId, messageText, fileId } = action.payload;
        state.data = state?.data?.map((m: any) => {
            const mJobId = typeof m.job_id === 'string' ? m.job_id : (m.job_id?._id || m.job_id?.id);
            const mSenderId = typeof m.sender_id === 'string' ? m.sender_id : (m.sender_id?._id || m.sender_id?.id);
            const mFileId = typeof m.file_id === 'string' ? m.file_id : (m.file_id?._id || m.file_id?.id);
            const isTempId = m._id && m._id.toString().startsWith('temp_');

            if (m._id === id || ((!m._id || isTempId) && mJobId === jobId && mSenderId === senderId && m.message === messageText && mFileId === fileId)) {
                return { ...m, readed: true };
            }
            return m;
        });
    }
  },
});
export const { updateNotificationMessage, removeNotificationMessage, markCleanerNotificationAsRead } =
  cleanerNotificationSlice.actions;
export default cleanerNotificationSlice.reducer;
